import { API } from './resources'

export default {
  trackUserSignup: (data) => {
    return API.post('/users/signup/track', data)
  }
}
